// Port of api/fuel/app/classes/filter/package/games/play/prepare/games/counts.php
export default {
	require: function(config, filter) { return filter.play && filter.play.group },
	run: function(local, global) {
		local.counts = [0, 0, 0, 0, 0, 0]
		var counts = (global.counts && global.counts[local.game_id]) ? global.counts[local.game_id] : []

		for (var i = 0; i < counts.length; i++) {
			var count = counts[i]
			if (!count) continue
			var index = parseInt(count.c, 10) || 0
			if (!index) continue
			if (index > 6) index = 6
			local.counts[index - 1] += parseInt(count.p, 10) || 0
		}

		return local
	}
}
